<script setup>
import JetButton from '@/Jetstream/Button.vue';
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import { Link } from '@inertiajs/inertia-vue3';
import JetNavLink from '@/Jetstream/NavLink.vue';
import { useForm, usePage } from '@inertiajs/inertia-vue3';
import { computed } from 'vue'

const honeypot = computed(() => usePage().props.value.honeypot)

const form = useForm({
    email: '',
    [honeypot.nameFieldName]: '',
    [honeypot.validFromFieldName]: honeypot.encryptedValidFrom,
});

const submit = () => {
    form.post(route('news-letter-subscriber.store'), {
        onSuccess: () => form.reset('email'),
    });
};

</script>

<template>

        <footer>
            <section class="top-footer">
                <div class="top-footer-cta position-relative w-100 p-5 d-block d-lg-none">
                    <h4>We are property specialists</h4>
                    <p class="mb-0">Are you ready to begin your journey?</p>
                    <a href="javascript:void(0);" class="btn custom-black-btn mt-4" data-bs-toggle="modal" data-bs-target="#enquiryModal">Get Inspired</a>
                    <img :src="asset('/images/homepage/cta-dot.png')" alt="">
                </div>
                <div class="container mt-5 mt-lg-0">
                    <div class="row">
                        <div class="col-lg-3">
                            <figure class="mb-0">
                                <img :src="asset('/images/logo-pgn-inspire-properties.png')" alt="">
                            </figure>
                        </div>
                    </div>
                </div>
                <div class="top-footer-cta position-absolute p-5 d-none d-lg-block">
                    <h4>We are property specialists</h4>
                    <p class="mb-0">Are you ready to begin your journey?</p>
                    <a href="javascript:void(0);" class="btn custom-black-btn mt-4" data-bs-toggle="modal" data-bs-target="#enquiryModal">Get Inspired</a>
                    <img :src="asset('/images/homepage/cta-dot.png')" alt="contact-us">
                </div>
            </section>
            <section class="mid-footer py-0 border-bottom overflow-hidden">
                <div class="container-fluid container-md m-0 m-md-auto">
                    <div class="row">
                        <div class="col-lg-6 col-xl-5 offset-xl-1 px-0 border-end alt-bg-footer left">
                            <div class="sub-section ps-xxl-1">
                                <p class="section-heading">
                                    Contact Us
                                </p>
                                <ul class="list-unstyled contact-links">
                                    <li>
                                        <span class="d-block">Email</span>
                                        <p><a href="mailto:info@inspire.properties">info@inspire.properties</a></p>
                                    </li>
                                    <li>
                                        <span class="d-block">Phone</span>
                                        <p><a :href="'tel:' + $page.props.phone">{{ $page.props.phone }}</a></p>
                                    </li>
                                    <li>
                                        <span class="d-block">Address</span>
                                        <p><a href="https://goo.gl/maps/Wg8bDPvHGJZfLc97A" target="_blank">2202, Saba 1, Cluster E, Jumeirah Lake Towers, Dubai, UAE</a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 px-0 right">
                            <div class="sub-section ">
                                <p class="section-heading">
                                    Quick Links
                                </p>
                                <ul class="list-unstyled hyper-links">
                                    <li>
                                        <p>
                                            <a :href="route('buy')">Buy</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('sell')">Sell</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('rent')">Rent</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('international-properties')">International Properties</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('buyers-handbook')">Buyer's Handbook</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('sellers-handbook')">Seller's Handbook</a>
                                        </p>
                                    </li>
                                    <li>
                                        <p>
                                            <a :href="route('neighbourhood-diaries')">Neighbourhood Diaries</a>
                                        </p>
                                    </li>
                                    <!-- <li>
                                        <p>
                                            <a :href="route('')">Blog</a>
                                        </p>
                                    </li> -->
                                </ul>
                            </div>
                            <div class="sub-section newsletter add-border-top">
                                <p class="section-heading">
                                    Newsletter Sign Up
                                </p>
                                <div class="input-group mb-3">
                                    <form action="#" method="post" class="d-flex" @submit.prevent="submit">
                                        <div v-if="honeypot.enabled" :name="`${honeypot.nameFieldName}_wrap`" style="display:none;">
                                            <input type="text" v-model="form[honeypot.nameFieldName]" :name="honeypot.nameFieldName" :id="honeypot.nameFieldName" />
                                            <input type="text" v-model="form[honeypot.validFromFieldName]" :name="honeypot.validFromFieldName" />
                                        </div>
                                        <input v-model="form.email" required maxlength="255" type="email" class="form-control custom-form-control" placeholder="Your Email*"
                                        aria-label="Your Email*" aria-describedby="basic-addon2">
                                        <button type="submit" class="input-group-text btn" :class="{ 'disabled': form.processing }" :disabled="form.processing">Subscribe</button>
                                    </form>
                                    <div class="d-block alert px-0" v-if="$page.props.flash.success">
                                        <p class="text-success">{{ $page.props.flash.success }}</p>
                                    </div>
                                    <div class="d-block alert px-0" v-if="$page.props.flash.error">
                                        <p class="text-danger">{{ $page.props.flash.error }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="bottom-footer py-0">
                <div class="container-fluid container-md">
                    <div class="row">
                        <div class="col-12 col-lg-6 col-xl-5 offset-xl-1 custom-border border-end py-3 py-md-5 order-1 order-lg-0 ps-4 ps-xl-0">
                            <p>Copyright &copy; 2012 - {{ new Date().getFullYear() }} <span class="highlight-color">Inspire Properties</span>. All
                                Rights Reserved.</p>
                        </div>
                        <div class="col-12 col-lg-6 offset-xl-1 col-xl-5 py-3 py-md-5 order-0 order-lg-1 ps-4">
                            <div class="social-links-wrapper">
                                <p class="text-uppercase d-block d-lg-none mb-4">Follow us</p>
                                <ul class="social-links list-unstyled mb-0 d-flex align-items-center">
                                    <li class="d-none d-lg-block">
                                        <span class="text-uppercase">Follow Us</span>
                                    </li>
                                    <li>
                                        <a href="https://www.facebook.com/Inspire-Properties-316365229135939" target="_blank">
                                            <i class="fa fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://twitter.com/InspirePropert2" target="_blank">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/inspirepropertiesdubai/" target="_blank">
                                            <i class="fa fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <!-- <li>
                                        <a href="https://www.youtube.com/channel/UCRR9Fw8UhTe3aj1P8t56BPQ" target="_blank">
                                            <i class="fa fa-youtube"></i>
                                        </a>
                                    </li> -->
                                    <li>
                                        <a href="https://www.instagram.com/inspirepropertiesdxb/" target="_blank">
                                            <i class="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </footer>
</template>
